import type { State, StateMethods } from "@hookstate/core";
import React from "react";
import ConfirmDialog from "~/components/ConfirmDialog";
import { useLang } from "~/hooks/useLang";

interface BackToAvailableProps {
    readonly openState: StateMethods<boolean>;
    readonly handleAgree: () => void;
    readonly handleClose: () => void;
    readonly isLoading?: State<boolean>
}

export default function BackToAvailable({ openState, handleAgree, handleClose, isLoading }: BackToAvailableProps) {
    const { translate } = useLang();

    return (
        <ConfirmDialog
            open={openState}
            title={translate('Back to available')}
            content={translate('Confirm this device back to available?')}
            handleClose={handleClose}
            handleAgree={handleAgree}
            loading={isLoading}
        />
    );
}